import React, { useRef, useState, useEffect, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import Success from './Success';
import ReCAPTCHA from "react-google-recaptcha";
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3'; // Uncomment this while using Google reCaptcha V3
//import { RECAPTCHA_SITE_KEY } from '../../constants/constants'; // Comment this while using Google reCaptcha V3
import WpAPI from '../../WpApi';
import { useUser } from '../../context/UserContext';
const HelpForm = (props) => {
    const { executeRecaptcha } = useGoogleReCaptcha(); // Uncomment this while using Google reCaptcha V3
    const ddRef = useRef();
    const captchaRef = useRef(null);
    const [userInfo, setUserInfo] = useState({});
    const [helpOption, setHelpOption] = useState();
    const [helpName, setHelpName] = useState('');
    const [helpEmail, setHelpEmail] = useState('');
    const [openDD, setOpenDD] = useState(false);
    const [processing, setProcessing] = useState(false);
    const [successResponse, setSuccessResponse] = useState(false);
    const [errorResponse, setErrorResponse] = useState(false);
    const [helpMessage, sethelpMessage] = useState('');
    const [loginError, setLoginError] = useState(false);
    const [error, setError] = useState({ textarea: '', option: '', token: '' });
    const [token, setToken] = useState("");
    const dispatch = useDispatch();
    const {
        membership,
        plan,
        user
    } = useUser();

    // Uncomment the function handleReCaptchaVerify and useEffect below it while using Google reCaptcha V3
    // Create an event handler so that we can call the verification on form submit
    const handleReCaptchaVerify = useCallback(async () => {
            if (!executeRecaptcha) {
                console.log("Execute recaptcha not yet available");
                return;
            }
            const reCaptchaToken = await executeRecaptcha("helpform");
            setToken(reCaptchaToken);
    }, [executeRecaptcha]);

    // We can use useEffect to trigger the verification as soon as the component being loaded
    useEffect(() => {
        handleReCaptchaVerify();
    }, [handleReCaptchaVerify]);

    const updateOption = (value) => {
        props.setOption(value);
    }

    const updateClickedOption = (value) => {
        props.setOption(value);
        setTimeout(() => { setOpenDD(false) }, 50);
    }

    const SubmitHelpData = () => {
        let loggedIn = WpAPI.isLoggedIn();
        if (loggedIn) {
            setLoginError(false);
            setProcessing(true);
            /**
             * START
             * Comment the token variable and captchaRef while using Google reCaptcha V3
             */
            //const token = captchaRef.current.getValue();
            //captchaRef.current.reset();
            /**
             * END
             */
            if (!helpName.length) {
                setError({ name: 'Please Enter the Name' });
                setProcessing(false);
            } else if (!helpEmail.length) {
                setError({ email: 'Please Enter the Email' });
                setProcessing(false);
            } else if (helpEmail.length && !(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(helpEmail))) {
                setError({ email: 'Please Enter valid Email' });
                setProcessing(false);
            } else if (!helpMessage.length) {
                setError({ textarea: 'Please Enter the Message' });
                setProcessing(false);
            } else if (!token) {
                setError({ token: 'Please Check Recaptcha' });
                setProcessing(false);
            } else {
                let obj = {
                    'subject': props.option,
                    'name': helpName,
                    'email': helpEmail,
                    'message': helpMessage
                }
                WpAPI.submitNeedHelpData(obj).then((res) => {
                    localStorage.removeItem("help_subject");
                    setProcessing(false);
                    setSuccessResponse(true);
                    setTimeout(() => {
                        setSuccessResponse(false);
                        setErrorResponse(false);
                        updateOption('');
                        props.setOpenHelpBox(false);
                    }, 3000);
                }).catch((e) => {
                    setErrorResponse(true);
                    setProcessing(false);
                    setTimeout(() => {
                        setSuccessResponse(false);
                        setErrorResponse(false);
                        updateOption('');
                        props.setOpenHelpBox(false)
                    }, 3000);
                });

            }
        } else {
            setLoginError(true);
            setProcessing(false);
        }
    }

    const onClickOutside = (e) => {
        if (e.target.classList.value != 'help-option')
            setOpenDD(false)
    }

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (ddRef.current && !ddRef.current.contains(event.target)) {
                onClickOutside && onClickOutside(event);
            }
        };
        document.addEventListener('click', handleClickOutside, true);
        return () => {
            document.removeEventListener('click', handleClickOutside, true);
        };
    }, [onClickOutside]);

    //let currentRef = useRef();

    useEffect(() => {
        //if(!currentRef.current) getUserInfo();
        //if (!currentRef.current && user != null) {
        //console.log('helpBox user: ', user)
        if (user != null) {
            //const user = props.user;
            user != undefined && setHelpName(user.firstname + ' ' + user?.lastname);
            user != undefined && setHelpEmail(user?.email);
            //currentRef.current = true;
        }
    }, [user]);

    // const getUserInfo = () => {
    //     if (WpAPI.isLoggedIn()) {
    //         // call fatchAccountInfo only if user is logged in otherwise login page redirection will be in the loop
    //         WpAPI.fetchAccountInfo().then((data) => {
    //             //console.log(data);
    //             !helpName && setHelpName(data.user.name);
    //             !helpEmail && setHelpEmail(data.user.email);
    //             setUserInfo(data.user);
    //         })
    //     }
    // }

    return (<>
        {!(successResponse || errorResponse) ? <div className={`helpbox helpbox2`}>
            <div className="helpbox2-details">
                <form encType="multipart/form-data" method="post" onSubmit={(e) => { e.preventDefault(); }}>
                    <div className="help-field mb">
                        <input type="hidden" name="help_option" value="" />
                        <div className="field-wrap">
                            <label htmlFor="help_name">Name</label>
                            <input
                                type="text"
                                name="help_name"
                                onChange={(e) => {
                                    setHelpName(e.target.value);
                                }}
                                onFocus={() => {
                                    setError({ name: '' });
                                }}
                                defaultValue={helpName} />
                            {error.name ? <span className="error-message">{error.name}</span> : ''}
                        </div>
                        <div className="field-wrap">
                            <label htmlFor="helper_name">Email Address</label>
                            <input
                                type="text"
                                name="help_email"
                                onChange={(e) => {
                                    setHelpEmail(e.target.value);
                                }}
                                onFocus={() => {
                                    setError({ email: '' });
                                }}
                                defaultValue={helpEmail} />
                            {error.email ? <span className="error-message">{error.email}</span> : ''}
                        </div>
                        {/* <div className="option-dropdown">
                            <span className="help-option" onClick={() => { setOpenDD(!openDD) }}>Subject: {props.option}</span>
                            {openDD ? <ul className="option-list" ref={ddRef}>
                                {HELP_OPTIONS.map((option) => {
                                    return (
                                        <li
                                            className={`${option.name == props.option ? 'selected' : ''}`}
                                            onClick={() => {
                                                updateClickedOption(option.name);
                                            }}
                                            key={option.id}>{option.name}</li>
                                    )
                                })}
                            </ul> : ''}
                        </div> */}
                        {/* <input type="text" name="subject" id="help-subject" onChange={(e) => {
                            updateOption(e.target.value);
                        }} value={`Subject: ${props.option}`} readOnly /> */}
                        <div className="field-wrap">
                            <label htmlFor="help_message">Message</label>
                        <textarea
                            name="help_message"
                                id="help-message"
                                value={helpMessage}
                                onChange={(e) => {
                                sethelpMessage(e.target.value);
                            }}
                            onFocus={() => {
                                setError({ textarea: '' });
                                setLoginError(false);
                            }}
                        ></textarea>
                            {error.textarea ? <span className="error-message">{error.textarea}</span> : ''}
                        </div>
                    </div>

                    <div className="help-recaptcha mb">
                        {/* <div className="captcha">
                            <ReCAPTCHA
                                sitekey={RECAPTCHA_SITE_KEY}
                                ref={captchaRef}
                            />
                        </div> */}
                        {error.token ? <span className="error-message">{error.token}</span> : ''}
                    </div>
                    <div className="field-wrap btn-field">
                        <input
                            type="submit"
                            name="get_help"
                            id="help-button"
                            value={processing ? 'submitting' : 'submit'}
                            onClick={() => {
                                setProcessing(true);
                                SubmitHelpData();

                            }} role='button' />
                    </div>
                    {loginError ? <p className="login-error">Please Login/Signup</p> : ''}
                </form>
            </div>
        </div> : ''}
        {(successResponse || errorResponse) ? <Success success={successResponse} error={errorResponse} /> : ''}
    </>);
}

export default HelpForm;